<template>
    <iframe
      src="app_introduce2.html"
      class="w-full"
      style="height: 1990px; width: 100%; border: none;"
      loading="lazy"
      referrerpolicy="no-referrer"
    ></iframe>
</template>
  
  <script>
  export default {
    name: 'Privacy'
  }
  </script>
  
  <style scoped>
  .privacy-container {
    max-width: 960px;
    margin: auto;
  
    /* 👇 上下 / 左右 padding */
    padding: 40px 24px;
  
    line-height: 1.8;
  }
  
  h1 {
    margin-bottom: 24px;
  }
  
  h2 {
    margin-top: 32px;
  }
  
  h3 {
    margin-top: 24px;
  }
  
  ul,
  ol {
    padding-left: 24px;
  }
  </style>
  